export default {
	userInfoPopupCustom: {
        borderRadius: "0px",
        maxWidth: "100%",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
		background: '#F8FAFB',
    },
	userInfoPopupOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 0
    },
    customPopupHeaderStyles: {
        padding: "12px 20px"
    },
	userInfoPopupChildren: {
        maxHeight:"100%", 
        height: '100%', 
        paddingBottom: '50px',
        flex:1,
        display: 'flex'
    },
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '7px', 
        flex:1
    },
    header: {
        display: 'flex', 
        justifyContent: 'center',
        marginBottom: "0px",
        lineHeight: "normal",
    },
    headerInfo: {
        display:'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: '10px'
    },
    recommendationText: {
        fontSize: '16px', 
        color: '#676767'
    },
    plansMainContainer: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: '50px', 
        padding: '10px 20px', 
        flex: 1
    },
    planBox: { 
        display:'flex', 
        flexDirection: 'column',
        gap: '30px', 
        borderRadius: '12px', 
        background: '#fff', 
        flex: 1, 
        height: '100%',
        maxWidth: '500px',
        minWidth: '320px'
    },
    greenBorder:{
        border: "1px solid #83CFA4",
        boxShadow: "1px 1px 1px 1px #83CFA4",
    },
    planInnerContainer: {
        display:'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
        borderRadius: '12px 12px 0px 0px',
        gap: '15px',
        padding: '10px 40px 0px',
        position:'relative'
    },
    topRightRibbon:{
        position:'absolute',
        right:"0"
    },
    h2FontSize: {
        fontSize: '24px'
    },
    pricingContainer: {
        display:'flex', 
        flexDirection: 'column', 
        gap: '10px'
    },
    labelFontSize: {
        fontSize: '14px'
    },
    featuresContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '10px'
    },
    planActionRow: {
        display: 'flex', 
        flexDirection: 'column', 
        gap: '20px'
    },
    checkBox: {
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px'
    },
    planDetails: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
        flex: 1,
        padding: '0px 20px 20px 20px', 
    },
    selectedText: {
        color: '#fff'
    },
    selectedBackground: {
        background: 'rgb(33, 93, 170)'
    },
    paddingTop: {
        paddingTop: '24px'
    }
}